import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './styles/global.css';
import './styles/variables.css';

// Mount React into the WordPress-injected div
const rootElement = document.getElementById('lep-portal-root');
if (rootElement) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(<App />);
} else {
  console.error('LEP: Root element #lep-portal-root not found');
}
